<template>
  <v-container>
    <base-sq-card
      :dialog="true"
    >
      <template v-slot:heading>
        <span class="tile-card-heading">Post Charges</span>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="blue lighten-2"
              dark
              large
              v-bind="attrs"
              v-on="on"
            >
              mdi-help-circle
            </v-icon>
          </template>
          <p>
            Post charges to the account based on recurring rates assigned.
          </p>
          <p>
            ie: If the customer has a monthly rate and the date is set for 6 months in the future, 6 invoices will be generated.
          </p>
        </v-tooltip>
      </template>
      <v-container>
        <v-row
          v-if="chargesPosted"
        >
          <v-col
            cols="10"
          >
            Charges have been posted for the account.
          </v-col>
        </v-row>
        <v-row v-if="!chargesPosted">
          <v-col cols="12">

          </v-col>
          <v-col cols="12">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="currentObject.date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                >
                  <template v-slot:label>
                    <span class="frm-textbox mb-1">Generate charges through...</span>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="currentObject.date"
                scrollable
                @input="menu = false"
              >
              </v-date-picker>
            </v-menu>

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-alert
              v-if="formErrors.length > 0"
              type="error"
            >
              <v-list
                color="error"
              >
                <v-list-item
                  v-for="(error, i) in formErrors"
                  :key="`error-${i}`"
                >
                  {{ error }}
                </v-list-item>

              </v-list>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="warning"
            @click="doCloseForm"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="!chargesPosted"
            text
            color="success"
            @click="doPostCharges"
          >
            Submit
          </v-btn>
        </v-row>
      </v-container>
      <v-overlay :value="overlayDisplay">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </base-sq-card>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import basicMixin from '../../mixins/basic'
  import {
    _COMMIT_LOG, ACCT_GET_ACCOUNT_INVOICES, ACCT_GET_ACCOUNT_RATES, ACCT_POST_CHARGES,
  } from '../../store/actions.types'

  export default {
    // events
    // formClosed
    name: 'AccountPostCharges',

    mixins: [basicMixin],

    props: {
    },
    data: () => ({
      baseObject: {
        date: '',
      },
      currentObject: {
      },
      menu: false,
      formMode: 'read',
      formErrors: [],
      overlayAbsolute: true,
      overlayDisplay: false,
      chargesPosted: false,
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'profile', 'apTypes', 'apStatuses', 'towers', 'optsBillingFreq', 'acctSelectedAccount']),
    },
    watch: {
    },
    created () {
      this.init()
    },
    methods: {
      ...mapActions({
        commitLog: _COMMIT_LOG,
        getAccountRates: ACCT_GET_ACCOUNT_RATES,
        getInvoices: ACCT_GET_ACCOUNT_INVOICES,
        postCharges: ACCT_POST_CHARGES,
      }),
      async init () {
        this.commitLog({ message: `Initializing ${name} setting values!` })
        this.resetForm()
      },
      async doPostCharges () {
        this.overlayDisplay = true
        const formValid = this.doVerifyForm()
        if (!formValid) {
          this.overlayDisplay = false
          return
        }
        try {
          const postPayload = {
            // rowkey: this.acctSelectedAccount.rowkey,
            date: this.currentObject.date,
          }
          const responseData = await this.postCharges(postPayload)
          if (responseData.success) {
            this.chargesPosted = true
            this.getAccountRates()
            this.getInvoices()
          } else {
            this.formErrors.push(responseData.responseText)
          }
        } catch (e) {
          console.log(e)
          this.formErrors = e.problems
        }
        this.overlayDisplay = false
      },
      doVerifyForm () {
        this.formErrors = []
        if (!this.currentObject.date || this.currentObject.date === '') {
          this.formErrors.push('Charge date must be selected')
        }
        return this.formErrors.length === 0
      },
      resetForm () {
        const date = this.currentObject.date
        this.currentObject = { ...this.baseObject }
        this.currentObject.date = date
        this.formErrors = []
        this.overlayDisplay = false
        this.chargesPosted = false
      },
      doCloseForm () {
        this.resetForm()
        this.$emit('closeForm')
      },
    },

  }
</script>
